/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */
export const GLOBAL_NOTIFY = 'app/App/GLOBAL_NOTIFY';
export const GLOBAL_MENU_OPEN = 'app/App/GLOBAL_MENU_OPEN';
export const GLOBAL_MENU_CLOSE = 'app/App/GLOBAL_MENU_CLOSE';
export const GLOBAL_NOTIFY_INFO = 'app/App/GLOBAL_NOTIFY_INFO';
export const GLOBAL_NOTIFY_SUCCESS = 'app/App/GLOBAL_NOTIFY_SUCCESS';
export const GLOBAL_NOTIFY_ERROR = 'app/App/GLOBAL_NOTIFY_ERROR';
export const ENQUEUE_NOTIFICATION = 'app/App/ENQUEUE_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'app/App/REMOVE_NOTIFICATION';
export const CLOSE_NOTIFICATION = 'app/App/CLOSE_NOTIFICATION';
export const SET_LOGGED_IN = 'app/App/SET_LOGGED_IN';
export const SET_BACKDROP_OPENED = 'app/App/SET_BACKDROP_OPENED';
export const LOGOUT = 'app/App/LOGOUT';
export const LOGOUT_SUCCESS = 'app/App/LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'app/App/LOGOUT_ERROR';
export const CHANGE_ORDER_ROUTE = 'app/App/CHANGE_ORDER_ROUTE';
export const FETCH_ACCOUNT_STATUS = 'app/App/FETCH_ACCOUNT_STATUS';
export const FETCH_ACCOUNT_STATUS_ERROR = 'app/App/FETCH_ACCOUNT_STATUS_ERROR';
export const FETCH_ACCOUNT_STATUS_SUCCESS =
  'app/App/FETCH_ACCOUNT_STATUS_SUCCESS';
export const FETCH_ACCOUNT_STATUS_RETRY = 'app/App/FETCH_ACCOUNT_STATUS_RETRY';
export const POS_DETAILS = 'app/App/POS_DETAILS';
export const POS_DETAILS_SUCCESS = 'app/App/POS_DETAILS_SUCCESS';
export const POS_DETAILS_ERROR = 'app/App/POS_DETAILS_ERROR';
export const GLOBAL_ACCOUNT_STATUS = 'app/App/GLOBAL_ACCOUNT_STATUS';
export const GLOBAL_ACCOUNT_STATUS_SUCCESS =
  'app/App/GLOBAL_ACCOUNT_STATUS_SUCCESS';
export const GLOBAL_ACCOUNT_STATUS_ERROR =
  'app/App/GLOBAL_ACCOUNT_STATUS_ERROR';
export const USER_LEGAL_INFO_TERMS = 'app/App/USER_LEGAL_INFO_TERMS';
